// @ts-nocheck
// TODO: tighten types after migration
import React, { useState } from "react";

// Helper to extract h1/h2/h3 headings from GraphCMS rich text JSON
function extractHeadings(richTextJson) {
  const headings = [];

  if (!richTextJson || !richTextJson.children || !Array.isArray(richTextJson.children)) {
    return [];
  }

  const stableHash = (input) => {
    const str = String(input || "");
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash).toString(36);
  };

  const slugify = (text) =>
    String(text || "")
      .toLowerCase()
      .replace(/[^\w]+/g, "-")
      .replace(/^-+|-+$/g, "");

  // Helper function to extract text from nested structures
  const extractText = (node) => {
    if (!node) return '';
    if (node.text) return node.text;
    if (node.children && Array.isArray(node.children)) {
      return node.children.map(child => extractText(child)).join('');
    }
    return '';
  };

  for (let i = 0; i < richTextJson.children.length; i++) {
    const node = richTextJson.children[i];
    const isHeading =
      node.type === "heading-one" ||
      node.type === "heading-two" ||
      node.type === "heading-three";

    if (isHeading) {
      // Extract text from all children (handles nested text nodes)
      const text = extractText(node);
      
      if (text && text.trim()) {
        const id = slugify(text) || `h-${stableHash(text)}`;
        
        // Determine heading level
        let level = 1;
        if (node.type === "heading-two") level = 2;
        else if (node.type === "heading-three") level = 3;
        
        headings.push({ text: text.trim(), id, level });
      }
    }
  }

  return headings;
}

export default function TableOfContent({ richTextJson }) {
  const [open, setOpen] = useState(true);
  const headings = extractHeadings(richTextJson);
  
  if (headings.length === 0) {
    return null;
  }

  return (
    <nav className={`toc-container ${open ? 'open' : ''}`}>
      <button className="toc-toggle" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls="toc-list">
        <span>In this article</span>
        <i className={open ? "fi fi-rr-angle-small-up" : "fi fi-rr-angle-small-down"}></i>
      </button>
      <ul id="toc-list" className="toc-list">
        {headings.map((heading, index) => (
          <li key={index} className={`toc-item-enhanced toc-level-${heading.level}`}>
            <a 
              href={`#${heading.id}`} 
              className="toc-link-enhanced"
              onClick={(e) => {
                e.preventDefault();
                // Try to find the element by ID
                let element = document.getElementById(heading.id);
                
                // If not found, try to find by class and text match
                if (!element) {
                  const headings = document.querySelectorAll('.rt-h1, .rt-h2, .rt-h3, .mongodb-post-area .rt-h1, .mongodb-post-area .rt-h2, .mongodb-post-area .rt-h3');
                  headings.forEach(h => {
                    const text = h.textContent || h.innerText || '';
                    const id = text.toLowerCase().replace(/[^\w]+/g, '-').replace(/^-+|-+$/g, '');
                    if (id === heading.id) {
                      element = h;
                    }
                  });
                }
                
                if (element) {
                  const offset = 100; // Add space above the heading
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                } else {
                  console.warn('⚠️ TableOfContent: Could not find heading element with ID:', heading.id);
                }
              }}
            >
              {heading.level === 1 && <span className="toc-bullet-same">•</span>}
              {heading.level === 2 && <span className="toc-bullet-same">•</span>}
              {heading.level === 3 && (
                <i className="fi fi-rr-arrow-turn-down-right toc-arrow-enhanced"></i>
              )}
              <span className="toc-text">{heading.text}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

